// extracted by mini-css-extract-plugin
export default {"errorModalWrapper":"styles_errorModalWrapper__MNUXm","infoModalWrapper":"styles_infoModalWrapper__kH+pW"};